import fpApiUtil from "./fp-api-util";

// MasterController#getValidations (POST /factoryplan/master/validation/validations) — 조회 전용,
// upsert/remove 없음. DataValidationService.doValidation()이 planScope+type(FP_VALID_TYPE_*) 기준으로
// BOM/BOR/Order/Item 4종 검증을 돌려 { validationType, errorCount, details[] } 목록을 반환한다.
const BASE = "factoryplan/master/validation/validations";

const getAll = (params) => fpApiUtil.postParams(BASE, params);

const fpValidationService = { getAll };
export default fpValidationService;
